<template>
  <div class="content">
    <table style="width: 100%">
      <tr v-show="visibleInsuranceNumber">
        <td>Nummer</td>
        <td>
          <SogDataLabel :value="data?.insuranceNumber" />
        </td>
      </tr>
      <tr v-show="visibleInsuranceNumber&&data?.evb">
        <td>eVb</td>
        <td>
          <SogDataLabel :value="data?.evb" />
        </td>
      </tr>
      <tr>
        <td>Kennzeichen</td>
        <td>
          <SogDataLabel :value="data?.kennzeichen" />
        </td>
      </tr>
      <tr v-show="visibleInsuranceNumber && _isRoot">
        <td>GDV Vers.-Scheinnummer</td>
        <td>
          <SogDataLabel :value="data?.versicherungsScheinnummer" />
        </td>
      </tr>
      <tr v-show="visibleInsuranceNumber && _isRoot">
        <td>GDV VB-Nummer</td>
        <td>
          <SogDataLabel :value="data?.versicherungsBestaetigungsNummer" />
        </td>
      </tr>
      <tr v-show="data?.datumVersicherungsBeginn">
        <td>GDV-Versicherungsbeginn</td>
        <td>
          <SogDataLabel
            :value="data?.datumVersicherungsBeginn"
            value-type="Date"
          />
        </td>
      </tr>
      <tr v-show="data?.kennzeichenDatumGueltigBis">
        <td>Kennzeichen gültig bis</td>
        <td>
          <SogDataLabel
            :value="data?.kennzeichenDatumGueltigBis"
            value-type="Date"
          />
        </td>
      </tr>
      <tr>
        <td>FIN</td>
        <td>
          <SogDataLabel :value="data?.fahrzeugIdentifizierungsNummer" />
        </td>
      </tr>
      <tr>
        <td>Fahrzeugart</td>
        <td>
          <SogDataLabel>{{ data?.fahrzeugArtDescription }}</SogDataLabel>
        </td>
      </tr>
      <tr>
        <td>Hersteller</td>
        <td>
          <SogDataLabel>{{ data?.fahrzeugHersteller }}</SogDataLabel>
        </td>
      </tr>
      <tr>
        <td>Text Fahrzeugklasse</td>
        <td>
          <SogDataLabel>{{ data?.textFahrzeugklasse }}</SogDataLabel>
        </td>
      </tr>
      <tr>
        <td>Text Aufbau</td>
        <td>
          <SogDataLabel>{{ data?.textAufbau }}</SogDataLabel>
        </td>
      </tr>
      <tr>
        <td>Haltername</td>
        <td>
          <SogDataLabel>{{ data?.halterVorname }} {{ data?.halterNachname }}</SogDataLabel>
        </td>
      </tr>
      <tr>
        <td>Halteraddresse</td>
        <td>
          <SogDataLabel>{{ data?.halterStrasse }} {{ data?.halterHausnummer }}</SogDataLabel>
        </td>
      </tr>
      <tr>
        <td />
        <td>
          <SogDataLabel>
            {{ data?.halterPostleitzahl }} {{ data?.halterWohnort }}<br>{{ data?.halterStaat }}
          </SogDataLabel>
        </td>
      </tr>
      <tr
        v-show="_isRoot && data?.statusId"
      >
        <td>Status</td>
        <td>
          <SogDataLabel :value="data?.statusDescription" />
        </td>
      </tr>
      <tr
        v-show="_isRoot && data?.vertragsEnde"
      >
        <td>Vertragsende</td>
        <td>
          <SogDataLabel
            :value-type="SogDataLabelValueType.DateTime"
            :value="data?.vertragsEnde"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import VehicleRegistration from "@/shared/model/VehicleRegistration";
import {useAccountStore} from "@/stores/accountStore";
import {ref} from "vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";

interface Props {
  data?: VehicleRegistration,
  visibleInsuranceNumber?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    data: undefined, visibleInsuranceNumber: true
  }
)

const _accountStore = useAccountStore()
const _isRoot = ref(_accountStore.isRoot)

</script>

<style scoped>
.content {
  max-width: 400px;
}

td {
  padding-right: 5px;
}
</style>
